import { ChainsList } from './ChainsList.main';

export { ChainsList };
